module.exports = __webpack_public_path__ + "static/fonts/AkkuratPro-Regular.cfc0f9e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AkkuratPro-Regular.eot
// module id = B0HW
// module chunks = 1